import React from "react";
import classNames from "classnames";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import PageIndex from "./PageIndex/PageIndex";
import PageList  from "./PageList/PageList";
import PageOverview from "./PageOverview/PageOverview";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Messages, MessagesProvider } from "../context/MessagesContext";
import PageQuadrant from "./PageQuadrant/PageQuadrant";
import PageItem from "./PageItem/PageItem";

const useFetch = <D extends unknown>(url: string): D | undefined => {
  const [data, setData] = React.useState<D>();

  React.useEffect(() => {
    fetch(url)
      .then((response) => response.json())
      .then((data: D) => {
        setData(data);
      })
      .catch((error) => {
        console.error(`fetch ${url} failed. Did the file exist?`, error);
      });
  }, [url]);

  return data;
};



export default function Wrapper() {

  // TODO is it worth moving all of these to contentful?
  const messages = useFetch<Messages>(
    `${process.env.PUBLIC_URL}/messages.json`
  );

    return (
      <MessagesProvider messages={messages}>
        <BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
          <Routes>
          <Route
              path={"/"}
              element={
                <div>
                  <div className="page">
                    <div className="page__header">
                      <Header pageName={'landing'} />
                    </div>
                    <div className={classNames("page__content")}>
                      <PageList />
                    </div>
                    <div className="page__footer">
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path={"/:radarName"}
              element={
                <div>
                  <div className="page">
                    <div className="page__header">
                      <Header pageName={'index' || ""} />
                    </div>
                    <div className={classNames("page__content")}>
                      <PageIndex />
                    </div>
                    <div className="page__footer">
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route path='/house' element={ <Navigate to="/engineering" /> }/>
            <Route
              path={"/:radarName/overview"}
              element={
                <div>
                  <div className="page">
                    <div className="page__header">
                    <Header pageName={'overview' || ""} />
                    </div>
                    <div className={classNames("page__content")}>
                      <PageOverview />
                    </div>
                    <div className="page__footer">
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path={"/:radarName/:quadrantName/:itemName"}
              element={
                <div>
                  <div className="page">
                    <div className="page__header">
                    <Header pageName={'quadrant' || ""} />
                    </div>
                    <div className={classNames("page__content")}>
                      <PageItem />
                    </div>
                    <div className="page__footer">
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path={"/:radarName/:quadrantName"}
              element={
                <div>
                  <div className="page">
                    <div className="page__header">
                    <Header pageName={'quadrant' || ""} />
                    </div>
                    <div className={classNames("page__content")}>
                      <PageQuadrant/>
                    </div>
                    <div className="page__footer">
                      <Footer />
                    </div>
                  </div>
                </div>
              }
            />
          </Routes>
        </BrowserRouter>
      </MessagesProvider>
    );
}
